import { NgModule } from '@angular/core';
import { RouterModule, Routes, ExtraOptions } from '@angular/router';
import { AddRoleComponent } from './component/add-role/add-role.component';
import { AdhocComponent } from './component/adhoc/adhoc.component';
import { AdminComponent } from './component/admin/admin.component';
import { CloseCancelDiagnosisComponent } from './component/close-cancel-diagnosis/close-cancel-diagnosis.component';
import { DiagnosticComponent } from './component/diagnostic/diagnostic.component';
import { DynamicOdlFormComponent } from './component/dynamic-odl-form/dynamic-odl-form.component';
import { HelpVehicleSessionsComponent } from './component/help-vehicle-sessions/help-vehicle-sessions.component';
import { HotlineComponent } from './component/hotline/hotline.component';
import { IdentifyFailureComponent } from './component/identify-failure/identify-failure.component';
import { InfoComponent } from './component/info/info.component';
import { MainFdrsComponent } from './component/main-fdrs/main-fdrs.component';
import { ManageRoleQualifierComponent } from './component/manage-role-qualifier/manage-role-qualifier.component';
import { ManageWarrantyDealerCodeComponent } from './component/manage-warranty-dealer-code/manage-warranty-dealer-code.component';
import { ManageuserComponent } from './component/manageuser/manageuser.component';
import { ManualDiagnosisComponent } from './component/manual-diagnosis/manual-diagnosis.component';
import { PostrepairprocedureComponent } from './component/postrepairprocedure/postrepairprocedure.component';
import { RepairProcedureComponent } from './component/repair-procedure/repair-procedure.component';
import { RepairqualificationComponent } from './component/repairqualification/repairqualification.component';
import { StartupComponent } from './component/startup/startup.component';
import { SymptomsComponent } from './component/symptoms/symptoms.component';
import { SbdrdsmappingComponent } from './component/sbdrdsmapping/sbdrdsmapping.component';
import { TargettingEngineOverrideComponent } from './component/targetting-engine-override/targetting-engine-override.component';
import { TargettingEngineStatusComponent } from './component/targetting-engine-status/targetting-engine-status.component';
import { TargettingEngineTestComponent } from './component/targetting-engine-test/targetting-engine-test.component';
import { VariantSummaryComponent } from './component/variant-summary/variant-summary.component';
import { GtacTemplateComponent } from './component/gtac-template/gtac-template.component';
import { VehicleSessionsComponent } from './component/vehicle-sessions/vehicle-sessions.component';
import { VehicleComponent } from './component/vehicle/vehicle.component';
import { WarrantyDealerCodeComponent } from './component/warranty-dealer-code/warranty-dealer-code.component';
import { OauthcredComponent } from './component/oauthcred/oauthcred.component';
import { FdrsViewComponent } from './component/fdrs-view/fdrs-view.component';
import { DiagnosticFdrsViewComponent } from './component/diagnostic-fdrs-view/diagnostic-fdrs-view.component';
import { NetworkTestComponent } from './component/network-test/network-test.component';
import { OtxCandidateComponent } from './component/otx-candidate/otx-candidate.component'
import { EtisCandidateComponent } from './component/etis-candidate/etis-candidate.component';
import { ErrorCandidateComponent } from './component/error-candidate/error-candidate.component';
import { GlobalManagedServicesComponent } from './component/global-managed-services/global-managed-services.component';
import { ShowRulesComponent } from './component/show-rules/show-rules.component';
import { RecurringRuleComponent } from './component/recurring-rule/recurring-rule.component';
import { OffroadRuleComponent } from './component/offroad-rule/offroad-rule.component';
import { VehicleSessionsViewComponent } from './component/vehicle-sessions-view/vehicle-sessions-view.component';
import { VehicleSessionsLinkComponent } from './component/vehicle-sessions-link/vehicle-sessions-link.component';

import { RepairPostRepairCandidateComponent } from './component/repair-post-repair-candidate/repair-post-repair-candidate.component';
import { ScheduleJobComponent } from './component/schedule-job/schedule-job.component';
import { AutomationToolComponent } from './component/automation-tool/automation-tool.component';
import { AdfsWebservicesComponent } from './component/adfs-webservices/adfs-webservices.component';
import { AdfsProfilesComponent } from './component/adfs-profiles/adfs-profiles.component';
import { AdfsClientsComponent } from './component/adfs-clients/adfs-clients.component';
import { GlobalSeriveEnabledComponent } from './component/global-serive-enabled/global-serive-enabled.component';
import { FeaturemappingsComponent } from './component/featuremappings/featuremappings.component';
import { DisplayDiagnosticComponent } from './component/display-diagnostic/display-diagnostic.component';
import { HelpdeskRvcComponent } from './component/helpdesk-rvc/helpdesk-rvc.component';
import { OauthRealmPropertiesComponent } from './component/oauth-realm-properties/oauth-realm-properties.component';
import { ReportAProblemPageComponent } from './component/report-a-problem-page/report-a-problem-page.component';
import { OTXReportComponent } from './component/otx-report/otx-report.component';
import { VehicleHelpComponent } from './component/vehicle-help/vehicle-help.component';
import { DTCDataComponent } from './dtcdata/dtcdata.component';
import { ImportDtcListViewComponent } from './component/import-dtc-list-view/import-dtc-list-view.component';
import { DataCollectorInformationComponent } from './component/data-collector-information/data-collector-information.component';
import { ViewDataCollectorInfoComponent } from './component/view-data-collector-info/view-data-collector-info.component';
import { UnauthorizedAccessViewComponent } from './component/unauthorized-access-view/unauthorized-access-view.component';
import { AddTempDealerCodeComponent } from './component/add-temp-dealer-code/add-temp-dealer-code.component';
import {ReportsComponent} from "./component/reports/reports.component";
import {ReportErrorsComponent} from "./component/report-errors/report-errors.component";
import {ReportVinIssueComponent} from "./component/report-vin-issue/report-vin-issue.component";
import {ReportReadVinComponent} from "./component/report-read-vin/report-read-vin.component";
import {ReportVciIssueComponent} from "./component/report-vci-issue/report-vci-issue.component";
import { CheckExistingSessionComponent } from './component/check-existing-session/check-existing-session.component';
import {
  ReportLostCommunicationComponent
} from "./component/report-lost-communication/report-lost-communication.component";
import {ReportVinMismatchComponent} from "./component/report-vin-mismatch/report-vin-mismatch.component";
import {ReportBrowserComponent} from "./component/report-browser/report-browser.component";
const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  onSameUrlNavigation: 'reload'
};

const routes: Routes = [
  // {path:'vehicle',component:VehicleComponent},
  { path: 'repair-postrepair', component: RepairPostRepairCandidateComponent },
  { path: 'diagnostic', component: DiagnosticComponent },
  { path: 'symptoms', component: SymptomsComponent },
  { path: 'networkTest', component: NetworkTestComponent },
  { path: 'otxCandidate', component: OtxCandidateComponent },
  { path: 'etisCandidate', component: EtisCandidateComponent },
  { path: 'errorCandidate', component: ErrorCandidateComponent },
  { path: 'info', component: InfoComponent },
  // {​​​​​​​​path :"manual" , component:ManualDiagnosisComponent}​​​​​​​​,
  { path: "identifyFailure", component: IdentifyFailureComponent },
  { path: "fdrs", component: MainFdrsComponent },
  { path: "closeCanceldiagnosis", component: CloseCancelDiagnosisComponent },
  { path: 'warrantyDealerCode', component: WarrantyDealerCodeComponent },
  { path: "hotline", component: HotlineComponent },
  { path: 'postrepairProcedures', component: PostrepairprocedureComponent },
  { path: 'repair', component: RepairqualificationComponent },
  { path: 'startup', component: StartupComponent },
  { path: 'displaydiagnostic', component: DisplayDiagnosticComponent },
  { path: 'helpdeskrvc', component: HelpdeskRvcComponent},
  { path: 'repairProcedures', component: RepairProcedureComponent },
  { path: 'vehicleHelp', component: VehicleHelpComponent },
  { path: 'vehicleSessions', component: VehicleSessionsComponent },
  { path: 'helpVehicleSessions', component: HelpVehicleSessionsComponent },
  { path: "mainfdrs", component: MainFdrsComponent },
  { path: "view", component: FdrsViewComponent },
  {
    path: 'showRules', component: ShowRulesComponent
  },
  { path: "reportAProblem", component: ReportAProblemPageComponent },
  { path: "diagnostic-view", component: DiagnosticFdrsViewComponent },
  { path: "manageWarrantyDealerCode", component: ManageWarrantyDealerCodeComponent },
  { path: "viewVehicleSessions", component: VehicleSessionsViewComponent },
  { path: "linkDetails", component: VehicleSessionsLinkComponent },
  { path: "globalServiceEnabled", component: GlobalSeriveEnabledComponent },
  { path: "OTX-report", component: OTXReportComponent },
  { path: 'DTCDataView', component: DTCDataComponent },
  { path: 'importDTCView', component: ImportDtcListViewComponent },
  { path: 'dataCollectorInfo', component: DataCollectorInformationComponent },
  { path: 'viewDataCollectorInfo', component: ViewDataCollectorInfoComponent },
  { path: 'unauthorizedAccess', component: UnauthorizedAccessViewComponent },
  { path: 'tempDealer', component: AddTempDealerCodeComponent},
  {path:'checkExisting',component:CheckExistingSessionComponent},



  {

    path: 'admin', component: AdminComponent,

    children: [
      {
        path: 'updateOverrideForm.do', component: TargettingEngineOverrideComponent
      },
      {
        path: 'targetingEngineTest.do', component: TargettingEngineTestComponent
      },
      {
        path: 'showRules', component: ShowRulesComponent
      },
      {
        path: 'recurringRule', component: RecurringRuleComponent
      },
      {
        path: 'offRule', component: OffroadRuleComponent
      },
      {
        path: 'teStatusPage.do', component: TargettingEngineStatusComponent
      },
      {
        path: 'variantSummary.do', component: VariantSummaryComponent
      },
      {
        path: 'reports.do' , component: ReportsComponent
      },
      {
        path: 'reportErrors.do' , component: ReportErrorsComponent
      },
      {
        path: 'reportVinIssue.do' , component: ReportVinIssueComponent
      },
      {
        path: 'reportReadVin.do' , component: ReportReadVinComponent
      },
      {
        path: 'reportVciIssue.do' , component: ReportVciIssueComponent
      },
      {
        path: 'reportLostCommunication.do' , component: ReportLostCommunicationComponent
      },
      {
        path: 'reportVinMismatch.do' , component: ReportVinMismatchComponent
      },
      {
        path: 'gtacTemplate.do', component: GtacTemplateComponent
      },
      {
        path: 'reportBrowser.do' , component: ReportBrowserComponent
      },
      {
        path: 'updateDynamicOdlForm.do', component: DynamicOdlFormComponent
      },
      {
        path: 'manageuser', component: ManageuserComponent
      },
      {
        path: 'addrole', component: AddRoleComponent
      },
      {
        path: 'globalManagedServices', component: GlobalManagedServicesComponent
      },
      {
        path: 'adhoc', component: AdhocComponent
      },
      {
        path: 'sbdrdsmapping', component: SbdrdsmappingComponent
      },
      {
        path: 'oauthrealmcred', component: OauthcredComponent
      },
      {
        path: 'manageRoleQualifiers.do', component: ManageRoleQualifierComponent
      },
      {
        path: 'scheduleJob', component: ScheduleJobComponent
      },
      {
        path: 'adfsProfiles', component: AdfsProfilesComponent
      },
      {
        path: 'automation', component: AutomationToolComponent
      },
      {
        path: 'adfsClients', component: AdfsClientsComponent
      },
      {
        path: 'adfsWebserives', component: AdfsWebservicesComponent
      },
      {
        path: 'featuremappings', component: FeaturemappingsComponent
      },
      {
        path: 'oauthProperties', component: OauthRealmPropertiesComponent
      },

    ]
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
